import { getComponentRequisitionOptionsFilter } from '@/constants/options/component-recommendation.option';
import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            {
                key: 'partRequisitionStatus',
                trans: 'partRequisitionStatus.componentRecommendation',
                defaultOperator: '=',
            },
        ],
        type: 'select',
        value: getComponentRequisitionOptionsFilter(true),
    },
    {
        key: [
            {
                key: 'taskCheck.ticket.customerId',
                trans: 'Customers',
                keyService: 'Customers',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.CUSTOMER],
            },
            {
                key: 'taskCheck.assigneeId',
                trans: 'Assignees.componentRecommendation',
                keyService: 'Assignees',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.KTV],
            },
        ],
        type: 'orm',
        value: [],
    },
];
